import type { MarketTemplate, MarketView, SubMarketGroupType } from '@ps/isp-web-services-types';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import type { ClientMarketGroup } from '../../../../../model/types';
import { getMarketName } from '../utils/getMarketName';
import { getSelectedSubMarketGroupTypeTemplates } from '../utils/getSelectedSubMarketGroupTypeTemplates';

interface GetTemplateForGroupProps {
  currentGroup: ClientMarketGroup | undefined;
  templates: MarketTemplate[];
  markets: Record<string, MarketView>;
  locale: string;
  selectedSubMarketGroupType: SubMarketGroupType | undefined;
}

export const useGetTemplatesForGroup = ({
  currentGroup,
  templates,
  markets,
  locale,
  selectedSubMarketGroupType
}: GetTemplateForGroupProps) => {
  const { formatMessage } = useRegulatoryIntl();

  if (!currentGroup) {
    return [];
  }

  if (currentGroup.type === 'ALL_MARKETS') {
    return templates.sort((a, b) =>
      getMarketName({ template: a, markets }, formatMessage).localeCompare(
        getMarketName({ template: b, markets }, formatMessage),
        locale,
        { sensitivity: 'base' }
      )
    );
  }

  return getSelectedSubMarketGroupTypeTemplates({
    currentGroup,
    templates,
    selectedSubMarketGroupType
  });
};
